import { toast } from 'react-toastify';
import { toastResponse } from '../../../helper components/Toast/Toast';

import Button from 'react-bootstrap/Button';
import lang from '../../../assets/i18n/en.json';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { emailValidation } from '../../../utils/Utils';
import './forgot.component.scss';
import { useMutation } from '@apollo/client';
import {ResetEnterpriseClientPasswordByEmail} from '../../../Mutations/Mutations';

export const Forgot = () => {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  const PAGE = lang.PAGE;
  const COMMON = lang.COMMON;

  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    email: '',
  });

  const [errors, setError] = useState({
    email: false,
    emailError: '',
  });

  //Assign mutaions to variable
  const [fnForgotPasswordEnterpriseClient, { loading }] = useMutation(
    ResetEnterpriseClientPasswordByEmail,
    {
      onCompleted: (data) => {
        toast.success(toastResponse('success', 'Reset password link sent to the respective email....'));
      },

      onError: ({ graphQLErrors }) => {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      },
    },
  );

  const onSubmit = async () => {
    try {
      // let data = {
      //     "enterpriseClientId": userData.id,
      //     "newPassword": resetPassword.password
      // }
      toast.success(toastResponse('success', 'Reset password Mutation Not Available.'));
      // if (data) {
      // fnForgotPasswordEnterpriseClient({
      //   variables: {
      //     email: userData.email,
      //   },
      // });
      // }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form className="form" novalidate="novalidate">
      <div className="pb-5 pb-lg-10">
        <p
          className="login-registration-form pageTitle h1 fw-bolder text-dark"
          id="forgot_password_title"
        >
          {PAGE.AUTH.FORGOT_PASSWORD.TITLE}
        </p>
        <p className="text-muted fw-bold" id="forgot_password_sub_title">
          {PAGE.AUTH.FORGOT_PASSWORD.SUB_TITLE}
        </p>
      </div>
      <div className="fv-row mb-10">
        <Form.Label className="loginRegisterBlock label text-dark">
          {PAGE.AUTH.SIGNIN.USERNAME.LABEL}
        </Form.Label>
        <Form.Control
          type="email"
          id="username"
          name="usernme"
          className="forgot-form form-control form-control-lg form-control-solid"
          placeholder={PAGE.AUTH.SIGNIN.USERNAME.PLACEHOLDER}
          onChange={(e) => {
            setUserData((userData) => ({ ...userData, email: e.target.value }));
            emailValidation(e.target.value, errors, setError);
          }}
          tabIndex="1"
          autoFocus
          required
          isInvalid={errors.email}
        />
        <Form.Control.Feedback
          type="invalid"
          id="email_validation_error"
          style={{ color: 'red' }}
        >
          {errors.emailError}
        </Form.Control.Feedback>
      </div>

      {/*
        <!--begin::Action--> */}
      <Button
        className="theme login-registration-form btn btn-primary  me-4"
        disabled={!(userData.email && !errors.email)}
        onClick={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        {PAGE.AUTH.FORGOT_PASSWORD.SUBMIT_BTN.LABEL} {loading && (
          <i className="spinner-grow spinner-grow-sm ms-3" role="status" />
        )}
      </Button>

      <Button
        className=" btn btn-secondary border-primary me-3"
        onClick={() => navigate('/user/login')}
      >
        {COMMON.LABEL.CANCEL}
      </Button>

      {/*
        <!--end::Action--> */}
    </form>
  );
};
